var _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDijittoExpressLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 60,
    viewBox: "0 0 380 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 45,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 48,
    fontWeight: 700,
    fill: "#1E3A8A",
    letterSpacing: -1
  }, "\n    \xD0ijitto\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 133,
    y: 45,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 48,
    fontWeight: 700,
    fill: "#374151",
    letterSpacing: -1
  }, "\n    Express\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDijittoExpressLogo);
export default __webpack_public_path__ + "static/media/dijitto-express-logo.3d61a29e327c7c0bf63c5e38da398705.svg";
export { ForwardRef as ReactComponent };